import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VSelect,_vm._b({attrs:{"items":_vm.partItems,"label":_vm.$t('Select parts'),"outlined":"","multiple":"","hide-details":"auto","clearable":""},model:{value:(_vm.parts),callback:function ($$v) {_vm.parts=$$v},expression:"parts"}},'v-select',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }